var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTab2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9599 13.7294C13.5118 13.7294 14.7699 12.4713 14.7699 10.9194C14.7699 9.36745 13.5118 8.10938 11.9599 8.10938C10.408 8.10938 9.1499 9.36745 9.1499 10.9194C9.1499 12.4713 10.408 13.7294 11.9599 13.7294Z",
    stroke: "#344266",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.15 20.1988C17.15 17.8688 14.83 15.9688 11.96 15.9688C9.09002 15.9688 6.77002 17.8588 6.77002 20.1988",
    stroke: "#344266",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12.5C21.5 17.75 17.25 22 12 22C6.75 22 2.5 17.75 2.5 12.5C2.5 7.25 6.75 3 12 3C13.31 3 14.56 3.25999 15.7 3.73999C15.57 4.13999 15.5 4.56 15.5 5C15.5 5.75 15.71 6.46 16.08 7.06C16.28 7.4 16.54 7.70997 16.84 7.96997C17.54 8.60997 18.47 9 19.5 9C19.94 9 20.36 8.92998 20.75 8.78998C21.23 9.92998 21.5 11.19 21.5 12.5Z",
    stroke: "#344266",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 5C23.5 5.32 23.46 5.62999 23.38 5.92999C23.29 6.32999 23.13 6.72 22.92 7.06C22.44 7.87 21.67 8.49998 20.75 8.78998C20.36 8.92998 19.94 9 19.5 9C18.47 9 17.54 8.60997 16.84 7.96997C16.54 7.70997 16.28 7.4 16.08 7.06C15.71 6.46 15.5 5.75 15.5 5C15.5 4.56 15.57 4.13999 15.7 3.73999C15.89 3.15999 16.21 2.64002 16.63 2.21002C17.36 1.46002 18.38 1 19.5 1C20.68 1 21.75 1.51002 22.47 2.33002C23.11 3.04002 23.5 3.98 23.5 5Z",
    stroke: "#344266",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9898 4.98438H18.0098",
    stroke: "#344266",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.52344V6.51343",
    stroke: "#344266",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTab2);
export default __webpack_public_path__ + "static/media/Tab2.12d2f1ab66b65bae19d03ff4b7c8193c.svg";
export { ForwardRef as ReactComponent };